module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Air-ballon-a2022f682f677cd3d88252f0da5dc69b.svg";